import React from 'react';
import { withAllContexts } from '../AllContextsWrapper';
import RangeSelect from './Calendar/RangeSelect';
import { Menu as MenuIcon, CalendarMonth as CalendarMonthIcon } from '@mui/icons-material';
import { HookSlot } from '../hooks/usePluginHooks';

class Header extends React.Component {
  toggleSideMenu = () => {
    if (this.props.app.state.shownComponent === 'sideMenu') {
      this.props.app.functions.setShownComponent(null);
    } else {
      this.props.app.functions.setShownComponent('sideMenu');
    }
  }

  render() {
    const { activeCalendar, calendars } = this.props.app.state;
    const isCamping = activeCalendar?.type === 'accommodation';
    
    // Theme-specific colors
    const headerBgClass = isCamping 
      ? "bg-taborisko-pine border-b border-taborisko-orange/20" 
      : "bg-splavma-teal border-b border-splavma-orange/20";
      
    const accentClass = isCamping ? "text-taborisko-gold" : "text-splavma-orange";

    return (
      <header className={`sticky top-0 z-50 shadow-md transition-colors duration-300 ${headerBgClass}`}>
        <div className="px-4 py-3">
          <div className="flex items-center justify-between">
            {/* Left Section */}
            <div className="flex items-center gap-4">
              <button
                onClick={this.toggleSideMenu}
                className="p-2 hover:bg-white/10 rounded-full transition-all duration-200"
                aria-label="menu"
              >
                <MenuIcon className="text-white" />
              </button>

              <HookSlot location="topbar.left" />

              <div className="flex flex-col">
                <h1 className="text-lg font-extrabold text-white leading-tight hidden md:block">
                  Kalendár rezervácií
                </h1>
                <span className={`text-[10px] font-bold uppercase tracking-widest hidden md:block ${accentClass}`}>
                  {isCamping ? "Táborisko Nová Dedinka" : "Splavma s.r.o."}
                </span>
              </div>
            </div>

            {/* Center Section */}
            <div className="flex items-center gap-4 ml-auto md:ml-0">
              <HookSlot location="topbar.center" />

              {/* Calendar Selector */}
              {activeCalendar && calendars.length > 0 && (
                <div className="relative group flex items-center">
                  <select
                    value={activeCalendar.id}
                    onChange={(e) => this.props.app.functions.setCalendar(parseInt(e.target.value))}
                    className="header-select rounded-full px-6 py-2 pr-12 h-10
                             focus:outline-none focus:ring-2 focus:ring-white/40 
                             transition-all duration-300 cursor-pointer appearance-none min-w-[140px] md:min-w-[180px] font-bold text-sm"
                  >
                    {calendars.map(calendar => (
                      <option
                        key={calendar.id}
                        value={calendar.id}
                        style={{ backgroundColor: '#1f2937', color: 'white' }}
                      >
                        {calendar.name}
                      </option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none text-white">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </div>
              )}

              {!this.props.hideFilters && (
                <div className="hidden lg:block">
                  <RangeSelect />
                </div>
              )}
            </div>

            {/* Right Section */}
            <div className="flex items-center gap-3">
              <HookSlot location="topbar.right" />

              {/* Mobile Calendar Button */}
              {!this.props.hideFilters && (
                <button
                  onClick={() => {
                    if (this.props.app.state.shownComponent !== 'navCal')
                      this.props.app.functions.setShownComponent('navCal');
                    else
                      this.props.app.functions.setShownComponent(null);
                  }}
                  className="md:hidden p-2 hover:bg-white/10 rounded-full transition-colors duration-200"
                  aria-label="calendar navigation"
                >
                  <CalendarMonthIcon className="text-white" />
                </button>
              )}
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default withAllContexts(Header);
